<script>
  export default {
    props: {
      selo: { type: String, default: '' },
      icone: { type: String, default: '' },
      cor: { type: String, default: 'azu' },
      titulo: { type: String, required: true },
      subtitulo: { type: String, default: '' },
      nota: { type: String, default: '' },
    },
    template: `
      <div class="blo" :class="'blo-' + cor">
        <div class="blo-cab">
          <span class="blo-selo">
            <i v-if="icone" class="fa" :class="icone"></i>
            <template v-else>{{ selo }}</template>
          </span>
          <div class="blo-txt">
            <div class="blo-tit">{{ titulo }}</div>
            <div v-if="subtitulo" class="blo-sub">{{ subtitulo }}</div>
          </div>
          <slot name="acao"></slot>
        </div>
        <div v-if="nota" class="blo-nota">{{ nota }}</div>
        <div class="blo-corpo"><slot></slot></div>
      </div>`,
  }
</script>

<style scoped>
  .blo { border: 1px solid #e6e9ed; border-radius: 7px; background: #fff; margin-bottom: 12px; overflow: hidden; }
  .blo:last-child { margin-bottom: 0; }
  .blo-cab { display: flex; align-items: center; gap: 10px; padding: 9px 12px; background: #f7f9fa; border-bottom: 1px solid #eef1f4; }
  .blo-selo { flex: none; display: inline-flex; align-items: center; justify-content: center; min-width: 34px; height: 22px; padding: 0 7px; border-radius: 5px; font-size: 10.5px; font-weight: 700; letter-spacing: .03em; }
  .blo-selo .fa { font-size: 11px; }
  .blo-txt { flex: 1 1 auto; min-width: 0; }
  .blo-tit { font-size: 13px; font-weight: 600; color: #1c2024; }
  .blo-sub { font-size: 11.5px; color: #8a939c; margin-top: 2px; line-height: 1.4; }
  .blo-nota { padding: 8px 12px; font-size: 11.5px; color: #6b747e; background: #fbfcfd; border-bottom: 1px solid #f2f4f6; line-height: 1.45; }
  .blo-corpo { padding: 12px; }

  .blo-cre { border-color: #cfe7dc; }
  .blo-cre .blo-cab { background: #f2faf6; border-bottom-color: #ddefe6; }
  .blo-cre .blo-selo { background: #e3f3ec; color: #0a6d4d; }

  .blo-deb { border-color: #ecd6d4; }
  .blo-deb .blo-cab { background: #fdf6f5; border-bottom-color: #f4e2e0; }
  .blo-deb .blo-selo { background: #fbeceb; color: #a13c3c; }

  .blo-azu { border-color: #d6e2f2; }
  .blo-azu .blo-cab { background: #f4f8fd; border-bottom-color: #e3ecf8; }
  .blo-azu .blo-selo { background: #e7effa; color: #2d6cb3; }

  .blo-amb { border-color: #f0e2c4; }
  .blo-amb .blo-cab { background: #fdf9f0; border-bottom-color: #f5ead4; }
  .blo-amb .blo-selo { background: #fdf3e0; color: #8a6d1f; }

  .blo-cin { border-color: #e2e6ea; }
  .blo-cin .blo-cab { background: #f7f9fa; }
  .blo-cin .blo-selo { background: #eef1f4; color: #6b747e; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/BlocoOperacao.vue